import { FunctionComponent } from 'react';
import './styles/Input.scss';
import { classNames } from '../../utils';

interface IInputProps {
  label: string;
  value: string;
  onChange: (newVal: string) => void;
  name: string;
  required?: boolean;
  disabled?: boolean;
  type?: React.HTMLInputTypeAttribute | 'textarea';
  rows?: number;
  min?: string;
  max?: string;
  maxLength?: number;
  placeholder?: string;
}
export const Input: FunctionComponent<IInputProps> = (props: IInputProps) => {

  const {
    label,
    value,
    onChange,
    name,
    required,
    disabled,
    type,
    rows,
    placeholder,
    min,
    max,
    maxLength
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e.target.value ?? '');
  }

  return (
    <div className='ppa-schedule-input'>
      <label className={classNames({
        disabled
      })}>
        {label}{required ? '*' :''}
      </label>
      {type === 'textarea' ? (
        <textarea
          aria-label={label}
          required={required}
          disabled={disabled}
          rows={rows}
          placeholder={placeholder}
          onChange={handleChange}
          value={value}
          name={name}
        />
      ) : (
        <input
          type={type}
          aria-label={label}
          required={required}
          disabled={disabled}
          placeholder={placeholder}
          onChange={handleChange}
          value={value}
          name={name}
          min={min}
          max={max}
          maxLength={maxLength}
        />
      )}
    </div>
  )
}